export default __webpack_public_path__ + "img/success.0838f26a.png";